import Component from '@glimmer/component';

export default class MwCenter extends Component {}
